import { Component, ViewEncapsulation } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { CheckboxComponent } from '../../../design-system/checkbox/checkbox.component';
import { CheckboxConfig } from "../../../design-system/checkbox/checkbox.modal";

@Component({
    selector: 'checkbox-cell',
    templateUrl: './checkbox-renderer.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CheckboxComponent]
})
export class CheckBoxRendererComponent implements ICellRendererAngularComp {
  params: any; 
  text: string = '';
  checkboxConfig: CheckboxConfig = {
    id: 'booleanOption',
    label: '',
    type: 'checkbox',
    isSelected: false,
    isDisabled: false
  };

  constructor() {
  }


  initilize(params: ICellRendererParams) {
    if (params.data) {
      this.params = params;
      this.checkboxConfig.isSelected = params.getValue();
      this.checkboxConfig.label = params.colDef.cellRendererParams?.showLabel ? params.data.text : '';
      this.checkboxConfig.isDisabled = params.data.isCheckboxDisabled;
    }
  }
  
  onClick(isChecked: boolean) {
    this.checkboxConfig.isSelected = isChecked;
    this.params.setValue(isChecked);
    if (this.params.onClick instanceof Function) {
      this.params.onClick(isChecked);
    }
  }

  agInit(params: any): void {
    this.initilize(params);
  }

    refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }
}




